import {
  NextContentfulImage,
  NextContentfulLoaderProps,
} from "@components/Image";
import VideoPlayer from "@components/VideoPlayer";
import { getVideoUrl } from "@components/VideoPlayer/utils";
import { ImageWrapperType } from "@customTypes/imageWrapper";
import { useEffect, useRef, useState } from "react";
import videoIcon from "../../public/image/vidicon.png";

import clsx from "clsx";
import styles from "./C09_VideoVimeoAndYoutube.module.scss";

export interface VideoVimeoAndYoutubeProps {
  referenceTitle?: string;
  ariaLabel?: string;
  inSublayout?: boolean;
  videoCode: string;
  isVimeoCode?: boolean;
  overlayImage: ImageWrapperType;
  isAutoPlay?: boolean;
}

const loaderConfig: NextContentfulLoaderProps = { fit: "fill" };

export const VideoVimeoAndYoutube = (props: {
  content: VideoVimeoAndYoutubeProps;
}) => {
  const { content } = props;

  const {
    referenceTitle,
    ariaLabel,
    inSublayout,
    videoCode,
    isVimeoCode,
    overlayImage,
    isAutoPlay,
  } = content;

  const videoUrl = getVideoUrl(isVimeoCode ? "vimeo" : "youtube", videoCode);

  const posterImage = isVimeoCode
    ? overlayImage?.fields.url
    : overlayImage
      ? overlayImage?.fields.url
      : videoCode
        ? `https://img.youtube.com/vi/${videoCode}/hqdefault.jpg`
        : null;
  const [isPlaying, setIsPlaying] = useState(isAutoPlay);
  const accessibleLabel = ariaLabel || referenceTitle || "Play video";
  const playerContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isPlaying && playerContainerRef.current) {
      playerContainerRef.current.focus();
    }
  }, [isPlaying]);

  const videoJSX = () => {
    return !videoCode ? null : (
      <div
        className={clsx(
          "component",
          styles.youtube,
          inSublayout && styles["two-col"]
        )}
      >
        <div className={styles["youtube-embed"]}>
          {!isPlaying ? (
            <button
              aria-label={accessibleLabel}
              className={styles["overlay-image"]}
              onClick={() => setIsPlaying(true)}
            >
              <div className={styles["play-icon"]}>
                <NextContentfulImage
                  aria-hidden
                  src={videoIcon}
                  alt=""
                  width={160}
                  height={160}
                />
              </div>
              {/* need to change null to a fallback image */}
              {posterImage && (
                <div className={styles["poster-image"]}>
                  <NextContentfulImage
                    src={posterImage}
                    alt=""
                    aria-hidden
                    width={inSublayout ? 640 : 1440}
                    height={inSublayout ? 360 : 810}
                    loaderConfig={loaderConfig}
                  />
                </div>
              )}
            </button>
          ) : (
            <div
              tabIndex={-1}
              ref={playerContainerRef}
              role="region"
              aria-label="Video player"
            >
              <VideoPlayer url={videoUrl} playing={isPlaying} controls />
            </div>
          )}
        </div>
      </div>
    );
  };

  return <>{inSublayout ? <div>{videoJSX()}</div> : <>{videoJSX()}</>}</>;
};

export default VideoVimeoAndYoutube;
